import React from 'react';

import { FormSubmit } from 'components/form';
import PropTypes from 'prop-types';

import ContentBasePageActions from './ContentBasePageActions';

const ContentBasePageFooter = (props) => {
  const {
    onSubmit,
    onSubmitAndReturn,
    cancelHandler,
    isSubmitDisabled,
    children,
    ...rest
  } = props;
  const hasOwnCallbackFunctions = onSubmit || onSubmitAndReturn;
  const Wrapper = hasOwnCallbackFunctions ? React.Fragment : FormSubmit;

  return (
    <Wrapper>
      <ContentBasePageActions
        isDisabled={isSubmitDisabled}
        {...(hasOwnCallbackFunctions && {
          onSubmit,
          onSubmitAndReturn
        })}
        cancelHandler={cancelHandler}
        {...rest}
      >
        <div className="_d-flex _align-items-center _justify-content-center _justify-content-lg-end _w-full _mr-lg-6">
          {children}
        </div>
      </ContentBasePageActions>
    </Wrapper>
  );
};

ContentBasePageFooter.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  onSubmitAndReturn: PropTypes.func,
  cancelHandler: PropTypes.func
};

export default ContentBasePageFooter;
